module.exports = __webpack_public_path__ + "static/media/cross-light-orange.90232137.svg";